if (!customElements.get('backing-options')) {
  class BackingOptions extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (event) => {
        const input = event.target;

        if (!(input instanceof HTMLInputElement)) return;
        if (!input.classList.contains('backing-option__input')) return;

        this.applyChoice(input);
      });
    }

    applyChoice(input) {
      const hero = this.querySelector('.backing-options__hero');
      const caption = this.querySelector('.backing-options__caption');
      const price = this.querySelector('.backing-options__price');
      const stock = this.querySelector('.backing-options__stock');
      const note = this.querySelector('.backing-options__note');
      const button = this.querySelector('.backing-options__add');

      if (hero instanceof HTMLImageElement) {
        const nextImage = input.dataset.image || '';
        if (nextImage) hero.src = nextImage;
        hero.alt = input.dataset.alt || '';
      }

      if (caption) caption.textContent = input.dataset.caption || '';
      if (price) price.textContent = input.dataset.price || '';
      if (stock) stock.textContent = input.dataset.stock || '';
      if (note) note.textContent = input.dataset.note || '';

      if (button instanceof HTMLButtonElement) {
        const label = button.querySelector('span');
        const nextLabel = input.dataset.button || '';

        if (label) {
          label.textContent = nextLabel;
        } else {
          button.textContent = nextLabel;
        }

        button.disabled = input.dataset.canAdd !== 'true';
      }
    }
  }

  customElements.define('backing-options', BackingOptions);
}
